export default __webpack_public_path__ + "static/media/Custom-HUD-Pop-Up (3 Layers, 3D).6c07eda0.jpg";